import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SiteDashboardService } from '../../site-dashboard.service';
import * as _ from 'underscore';
import { SideMenuService } from '../../../../shared/side-menu/side-menu.service';
import { SelectPlinkComponent } from './select-plink/select-plink.component';
import { Subscription } from 'rxjs';
import { CommonUtil } from '../../../../shared/services/utility/common.service';

@Component({
  selector: 'app-plinks-dashboard',
  templateUrl: './plinks-dashboard.component.html',
  styleUrls: ['./plinks-dashboard.component.css']
})
export class PlinksDashboardComponent implements OnInit, OnDestroy {

  plinkInfo: any = {};
  customerID: number = 0;
  plinkID: number = 0;
  plinksIDs: any = [];
  siteID: number = 0;
  hasPlinks: boolean = true;
  dateRange: any = {};
  activePage: string;
  viewName: string;
  analyticsTab: string;
  siteSubscription: Subscription;
  routeParamsSubscription: Subscription;
  queryParamsSubscription: Subscription;
  activeDashboardSubscription: Subscription;
  currentSite: any = {};

  // Site data for analytics
  sitePlinksData: any = {};
  siteTags: any = {};
  sitePlinksTags: any = {};
  customerName: string = '';
  siteName: string = '';

  // Appearance flags for select-plink component
  showElementsFlags: any = {};

  @ViewChild('selectPlink') selectPlink: SelectPlinkComponent;

  constructor(
    private route: ActivatedRoute,
    private siteDashboardService: SiteDashboardService,
    private sideMenu: SideMenuService,
    private router: Router,
    private commonUtil: CommonUtil
  ) { }

  ngOnInit() {
    // Initialize page data from route
    this.activePage = this.route.snapshot.data['pageName'];
    this.viewName = this.route.snapshot.data['viewName'];
    this.customerID = this.route.parent.parent.snapshot.params.customerid || 0;
    this.siteID = this.route.parent.parent.snapshot.params.siteid || 0;

    // Subscribe to route params for all pages that use route parameters (outside site subscription to prevent loops)
    this.routeParamsSubscription = this.route.params.subscribe(params => {
      if(this.activePage == 'analytics' || this.activePage == 'notes' || this.activePage == 'settings' || this.activePage == 'quick-view' || this.activePage == 'plink-events' || this.activePage == 'rt-records') {
        const newPlinkID = Number(params['plinkID']) || 0;

        // Only update if the plinkID actually changed to prevent unnecessary updates
        if(newPlinkID !== this.plinkID) {
          this.plinkID = newPlinkID;
          // Update plinksIDs array to keep it in sync
          if(this.plinkID) {
            this.plinksIDs = [this.plinkID];
            // Create a minimal plinkInfo object for the dropdown
            this.plinkInfo = { deviceid: this.plinkID };
          }
        }

        if(this.activePage == 'analytics')
          this.analyticsTab = params['tab'];
      }
    });

    this.queryParamsSubscription = this.route.queryParams.subscribe( params => {
      // Only handle pages that still use query params (not settings, notes, plink-events, or rt-records anymore)
      if(this.activePage == 'connectivity-track' || this.activePage == 'debug-records' || this.activePage == 'config-track') {
        let plinksIDs = params['plinksIDs'] || '';

        plinksIDs = _.map(plinksIDs.split(','), function(value){ return parseInt(value, 10); });

        if(!plinksIDs[0]) {
          this.plinksIDs = [];
          this.plinkID = 0;
        } else {
          this.plinksIDs = plinksIDs.filter((elem, pos) => {
            return plinksIDs.indexOf(elem) == pos && elem;//unique array of IDs
          });
          this.plinkID = Number(this.plinksIDs[0]) || 0;
        }
      }
    });

    // Subscribe to site changes
    this.siteSubscription = this.sideMenu.currentSite.subscribe(siteInfo => {
      if(!siteInfo.id)
        return;

      this.currentSite = siteInfo;
      this.customerName = siteInfo.customer_name || '';
      this.siteName = siteInfo.name || '';
    });

    // Set active tab only once during initialization
    this.siteDashboardService.setActiveTab('polarlink');

    // Subscribe to dashboard data for analytics
    this.activeDashboardSubscription = this.siteDashboardService.activeDashboardData.subscribe(data => {
      if (data && data.chargersInSite) {
        this.sitePlinksData = this.commonUtil.arrayToAssociativeArray(data.chargersInSite.list, 'id');

        this.siteTags = [];
        var Tags = data.chargersInSite.tags;
        var siteTags = Tags.siteTags;
        var deviceTags = Tags.deviceTags;

        for(var i in siteTags) {
          this.siteTags.push(siteTags[i]);
        }

        this.sitePlinksTags = {};
        for(let plinkId in deviceTags) {
          let plinkTagsIds = deviceTags[plinkId];
          for (let i in plinkTagsIds) {
            let tag = plinkTagsIds[i];
            let tagId = tag.tagid;
            if (!this.sitePlinksTags[tagId]) {
              this.sitePlinksTags[tagId] = [];
            }
            this.sitePlinksTags[tagId].push(plinkId);
          }
        }
      }
    });

    // Load dashboard data for PolarLinks
    this.siteDashboardService.getChargersDashboardData(this.customerID, this.siteID);
  }



  ngOnDestroy() {
    if(this.siteSubscription)
      this.siteSubscription.unsubscribe();
    if(this.routeParamsSubscription)
      this.routeParamsSubscription.unsubscribe();
    if(this.queryParamsSubscription)
      this.queryParamsSubscription.unsubscribe();
    if(this.activeDashboardSubscription)
      this.activeDashboardSubscription.unsubscribe();
  }

  onPlinkSelect(plink) {
    if(this.activePage == 'connectivity-track' || this.activePage == 'debug-records' || this.activePage == 'config-track') {
      // Legacy pages still use query params and receive just the ID
      this.plinkID = plink.deviceid;
      this.plinksIDs = [this.plinkID || 0];
      this.plinkInfo = plink;
      if(!this.plinkInfo || this.plinkInfo.deviceid !== this.plinkID) {
        this.plinkInfo = { deviceid: this.plinkID };
      }
    } else {
      // Analytics, Notes, Events, Settings, and QuickView all work the same way now - receive full object
      // The select-plink component already handles URL updates via location.go()
      // We just need to update the component state here
      if(plink && plink.deviceid) {
        this.plinkInfo = plink;
        this.plinkID = plink.deviceid;
        // Keep plinksIDs in sync for Settings tab compatibility
        this.plinksIDs = [this.plinkID];
      }
    }
  }

  onDatesChanged(dateRange) {
    this.dateRange = dateRange;
  }

  onTabChanged(tabInfo) {
    // Tab change events - no special handling needed now that all tabs use consistent routing
  }

  updateActivePage(activePage) {
    let url: any[] = [...activePage, this.plinkID || 0];
    return this.router.navigate(url, {relativeTo: this.route.parent});
  }

  updateAppearanceElementsFlags(object) {
    this.showElementsFlags = _.extend(this.showElementsFlags, object);
  }
}
